var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M16.829 17.011v-2.24h-.8v2.56l1.72 1.72.56-.56zm-5.2-11.84-4.74 2.74 4.74 2.74 4.74-2.74zm-7.2 9.58v-6.36a1.56 1.56 0 0 1 .8-1.38l5.6-3.22q.2-.1.39-.16t.41-.06.42.06.38.16l5.6 3.22q.38.22.59.58t.21.8v3.18h-1.6v-2.32l-5.62 3.24-5.58-3.24v5.48l4.8 2.78v1.84l-5.6-3.22a1.6 1.6 0 0 1-.59-.58q-.21-.36-.21-.8m12 6.42q-1.66 0-2.83-1.17t-1.17-2.83 1.17-2.83q1.17-1.17 2.83-1.17 1.658 0 2.83 1.17 1.171 1.171 1.17 2.83-.003 1.66-1.17 2.83-1.17 1.172-2.83 1.17"
  })));
};
export default SvgHistory;